import {
    Component,
    OnInit,
    Input,
    ViewChild,
    Output,
    EventEmitter
} from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainAttachment
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    MasterConstants,
    JobOperationActions,
    GlitchOperationActions
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import {
    GuestLookup,
    Staff_Search_Assigment
} from "../../Models/ResponseModels";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import {
    CallDescriptionLookup,
    CallCategoryLookup,
    LocationLookup
} from "../../Models/GlobalEntities";
import {
    NgbModal,
    NgbActiveModal,
    NgbModalRef,
    NgbModalOptions
} from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { AppSettings } from "../../Library/AppSettings";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { GlitchService } from "../../Services/GlitchService";

@Component({
    selector: "CallAttachment",
    templateUrl: "./CallAttachment.html"
})
export class CallAttachment extends BaseComponent implements OnInit {
    @ViewChild("content") content;
    ModalRef: NgbModalRef;
    Model: any;
    lstBind: Array<ComplainAttachment> = [];
    @Input() OnlyNew: boolean = false;
    _MasterConstants = MasterConstants;
    MaximumUploadSize: any;

    @Input() Entity: EntityCodes = EntityCodes.Complain;

    @Output() AttachmentChanged: EventEmitter<
        Array<ComplainAttachment>
    > = new EventEmitter<Array<ComplainAttachment>>();

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        private complainService: ComplainService,
        private modalService: NgbModal,
        private _sanitizer: DomSanitizer,
        public glitchService: GlitchService
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        //this._sanitizer.bypassSecurityTrustUrl()
    }

    Open(Model: any): void {
        this.ClearErrors();
        this.Model = _.cloneDeep(Model);
        this.MaximumUploadSize = AppSettings.MaxUploadSize_MB() + " MB";

        if (this.OnlyNew) {
            this.Model.Attachments = [];
        } else {
            //this.Model = Model;
        }

        this.SetBinder();
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "lg",
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
    }

    SetBinder(): void {
        this.lstBind = this.Model.Attachments.filter(a => {
            return a.IsDeleted == false;
        });

        //if (this.OnlyNew == false) {

        //}
        //else {
        //    this.lstBind = this.Model.Attachments.filter(a => {
        //        return (a.CallRegAttachmentId == null);
        //    })
        //}
    }

    onDelete(idx: number): void {
        let row = this.Model.Attachments[idx];
        if (row.CallRegAttachmentId == null || row.CallRegAttachmentId <= 0) {
            this.Model.Attachments.splice(idx, 1);
        } else {
            row.IsDeleted = true;
        }

        this.SetBinder();
    }

    onSelect(): void {
        if (this.OnlyNew) {
            this.ClearErrors();
            this.ValidateSize();
            if (this.HasErrors) return;

            this.onSubmit();
        } else {
            this.ClearErrors();
            this.ValidateSize();
            if (this.HasErrors) return;

            this.AttachmentChanged.emit(this.Model.Attachments);
            this.ModalRef.close();
        }
    }

    GetExtenstion(filename: string): string {
        return filename.split(".").pop();
    }

    IsFileAccepted(filename: string): boolean {
        let ext = this.GetExtenstion(filename);
        return MasterConstants.IsInAcceptedAttachments(ext);
    }

    onFileChanged(fileInput: any): void {
        //console.info(fileInput);
        if (fileInput.target.files && fileInput.target.files[0]) {
            let objThis = this;

            for (let i = 0; i < fileInput.target.files.length; i++) {
                this.ClearErrors();
                let file = fileInput.target.files[i];

                const regex = new RegExp(/^([a-zA-Z0-9 _-]{1,}\.[a-zA-Z0-9]{1,10})$/);
                if (file.name.trim().length > 200) {
                    let errorText = this.translate.instant("ERR.ERR_LONG_FILENAME");
                    this.AddError(errorText);
                    return;
                }
                if (!regex.test(file.name.trim())) {
                    let errorText = this.translate.instant("ERR.ERR_SPECIAL_CHAR_NOT_ALLOWED");
                    this.AddError(errorText);
                    return;
                }

                if (this.IsFileAccepted(file.name) == false) {
                    let strError = this.GetTranslation(
                        "ERR.ERR_ATTACH_FILE_TYPE_ALLOWED"
                    );
                    strError = strError.replace(
                        "#filetype#",
                        this.GetExtenstion(file.name)
                    );
                    strError = strError.replace(
                        "#acceptedformat#",
                        MasterConstants.GetAcceptedExtensionsAsString()
                    );

                    this.AddError(strError);
                } else {
                    let reader = new FileReader();

                    reader.onload = function(e: any) {
                        let data: any = new ComplainAttachment();
                        data.Base64String = e.target.result;
                        data.FileName = file.name;
                        data.IsDeleted = false;
                        data.FileSize = file.size;
                        objThis.Model.Attachments.push(data);

                        objThis.SetBinder();
                    };

                    reader.readAsDataURL(file);
                }
            }
        }
        fileInput.target.value = "";
    }

    ValidateSize(): void {
        if (
            this.Model == null ||
            this.Model.Attachments == null ||
            this.Model.Attachments.length == 0
        )
            return;

        let totalSize = 0;
        for (let i = 0; i < this.Model.Attachments.length; i++) {
            let row: any = this.Model.Attachments[i];
            totalSize += row.FileSize;
        }

        if (totalSize > AppSettings.MAX_UPLOAD_SIZE) {
            let errorText = this.translate.instant("ERR.ERR_ATTACHMENT_SIZE");
            this.AddError(
                errorText + " " + AppSettings.MaxUploadSize_MB() + " MB"
            );
        }
    }

    onSubmit(): void {
        if (this.Model == null) return;

        this.ClearErrors();

        this.ValidateSize();

        if (this.HasErrors) {
            return;
        }

        if (
            this.Model.Attachments == null ||
            this.Model.Attachments.length == 0
        ) {
            this.ModalRef.close();
            return;
        }

        switch (this.Entity) {
            case EntityCodes.Complain:
                this.SubmitComplain();
                break;
            case EntityCodes.Glitch:
                this.SubmitGlitch();
                break;
        }
    }

    SubmitComplain(): void {
        this.Model.Operation = JobOperationActions.ChangeAttachments;
        this.SubmitStart();
        this.complainService.Complain_Update(this.Model).then(data => {
            this.SubmitEnd();
            this.FromBaseResponse(data);
            if (this.HasErrors) return;

            this.GetMultilingualToast("TS.TS_FILE_UPDATED_SUCCESS", "success");

            this.AttachmentChanged.emit(data.Result.OLTPData.Attachments);
            this.ModalRef.close();
        });
    }

    SubmitGlitch(): void {
        this.Model.Operation = GlitchOperationActions.EditAttachment;

        console.info(this.Model);
        this.SubmitStart();
        this.glitchService.Glitch_Register(this.Model).then(data => {
            this.SubmitEnd();
            this.FromBaseResponse(data);
            if (this.HasErrors) return;

            this.GetMultilingualToast("TS.TS_FILE_UPDATED_SUCCESS", "success");

            this.AttachmentChanged.emit(data.Result.Attachments);
            this.ModalRef.close();
        });
    }
}
